import { render, staticRenderFns } from "./YourCards.vue?vue&type=template&id=b83b3b66&"
import script from "./YourCards.vue?vue&type=script&lang=js&"
export * from "./YourCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports